var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeleccion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ico_PWA_objetivo_line_color",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.282,
    height: 70.282,
    viewBox: "0 0 70.282 70.282",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15989",
    "data-name": "Grupo 15989",
    transform: "translate(1.03 1.03)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1507",
    "data-name": "Elipse 1507",
    cx: 31.454,
    cy: 31.454,
    r: 31.454,
    transform: "translate(0 5.315)",
    fill: "#b1e0de"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1508",
    "data-name": "Elipse 1508",
    cx: 22.808,
    cy: 22.808,
    r: 22.808,
    transform: "translate(8.646 13.961)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1509",
    "data-name": "Elipse 1509",
    cx: 14.162,
    cy: 14.162,
    r: 14.162,
    transform: "translate(17.292 22.607)",
    fill: "#ee2b7c"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1510",
    "data-name": "Elipse 1510",
    cx: 5.516,
    cy: 5.516,
    r: 5.516,
    transform: "translate(25.939 31.253)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15988",
    "data-name": "Grupo 15988",
    transform: "translate(53.285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76869",
    "data-name": "Trazado 76869",
    d: "M403.008,7.644l-6.9,6.9a1.462,1.462,0,0,0-.425,1.125l.4,6.367,8.13-8.13-.373-5.948a.487.487,0,0,0-.83-.314Z",
    transform: "translate(-395.68 -7.5)",
    fill: "#fce3ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76870",
    "data-name": "Trazado 76870",
    d: "M413,55.368l-6.9,6.9a1.462,1.462,0,0,1-1.125.425l-6.367-.4,8.13-8.13,5.948.373A.487.487,0,0,1,413,55.368Z",
    transform: "translate(-398.21 -47.758)",
    fill: "#fce3ed"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_76871",
    "data-name": "Trazado 76871",
    d: "M61.176,17a2.492,2.492,0,0,0,1.761-.73l6.9-6.9a1.518,1.518,0,0,0-.978-2.586l-3.672-.23,2.4-2.4A1.03,1.03,0,1,0,66.128,2.7l-2.4,2.4L63.5,1.424A1.518,1.518,0,0,0,60.915.447l-6.9,6.9a2.492,2.492,0,0,0-.725,1.917l.237,3.779A32.488,32.488,0,0,0,8.45,59.653a1.03,1.03,0,0,0,1.523-1.386,30.44,30.44,0,0,1,43.3-42.717l-4.7,4.7A23.822,23.822,0,0,0,11.286,48.7h0a23.837,23.837,0,0,0,44.54-6.05,1.029,1.029,0,1,0-2.016-.418,21.778,21.778,0,0,1-40.694,5.524h0a21.494,21.494,0,0,1-2.41-9.952A21.756,21.756,0,0,1,47.124,21.7L42.468,26.36a15.21,15.21,0,1,0,1.456,1.456L48.58,23.16a21.685,21.685,0,0,1,5.682,14.513A1.03,1.03,0,0,0,55.291,38.7H55.3a1.03,1.03,0,0,0,1.024-1.035A23.739,23.739,0,0,0,50.036,21.7l4.7-4.7a30.441,30.441,0,0,1-41.385,44.45,1.03,1.03,0,1,0-1.3,1.6A32.485,32.485,0,0,0,64.967,37.8a32.221,32.221,0,0,0-6.389-19.348q-.649-.874-1.349-1.7c4.036.254,3.818.243,3.946.243ZM45.616,37.8a13.148,13.148,0,1,1-4.608-9.981L36.323,32.5A6.554,6.554,0,1,0,37.78,33.96l4.685-4.685A13.075,13.075,0,0,1,45.616,37.8Zm-13.86.728a1.03,1.03,0,0,0,1.456,0L36.3,35.442a4.491,4.491,0,1,1-1.456-1.456l-3.086,3.086a1.03,1.03,0,0,0,0,1.456ZM55.345,9.135a.431.431,0,0,1,.126-.332l6.051-6.05.269,4.285L55.6,13.226Zm1.713,5.547,6.188-6.188,4.285.269-6.051,6.051a.43.43,0,0,1-.332.126Z",
    transform: "translate(0 -0.002)",
    fill: "#3b0310"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeleccion);
export default __webpack_public_path__ + "static/media/seleccion.3ed9c1d8ac273197b66891736456087a.svg";
export { ForwardRef as ReactComponent };